/* note-limit.js — Reformation/Sleek shared */
(function () {
  const LIMIT = 250;

  // Count code points so emojis count as a single char
  const countChars = (str) => Array.from(str || "").length;
  const sliceChars = (str, n) => Array.from(str || "").slice(0, n).join("");

  // Attach limiter + counter to a textarea
  function attach(el) {
    if (!el || el.dataset.noteLimiterAttached === "true") return;
    el.setAttribute("maxlength", LIMIT); // native guard (works on <textarea>)
    el.setAttribute("aria-describedby", el.id ? `${el.id}-note-counter` : "");
    el.dataset.noteLimiterAttached = "true";

    // Counter element
    const counter = document.createElement("div");
    counter.className = "note-counter";
    counter.id = el.id ? `${el.id}-note-counter` : "";
    counter.setAttribute("aria-live", "polite");
    counter.style.marginTop = "4px";
    counter.style.fontSize = "12px";
    counter.style.opacity = "0.75";

    const update = () => {
      // Enforce limit in a Unicode-safe way
      const val = el.value || "";
      const len = countChars(val);
      if (len > LIMIT) {
        el.value = sliceChars(val, LIMIT);
      }
      const remaining = LIMIT - countChars(el.value || "");
      counter.textContent = `${remaining} characters left`;
      counter.style.color = remaining === 0 ? "#b91c1c" : "";
      el.closest(".cart-note, .field, form")?.classList.toggle("note-limit-hit", remaining === 0);
    };

    el.addEventListener("input", update);
    el.addEventListener("blur", update);

    // Insert counter right after the textarea
    el.parentNode.insertBefore(counter, el.nextSibling);
    update();
  }

  // Find all possible note fields (cart page + drawers across themes)
  function findNoteTextareas(root = document) {
    return Array.from(
      root.querySelectorAll(
        [
          'textarea[name="note"]',                    // Shopify standard
          'textarea[id*="CartSpecialInstructions"]',  // Common alt id
          'textarea[data-cart-note]',                 // Some themes
        ].join(",")
      )
    );
  }

  // Initial attach
  findNoteTextareas().forEach(attach);

  // Observe for drawer re-renders / AJAX swaps
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === "childList") {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          findNoteTextareas(node).forEach(attach);
        });
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Expose for manual re-init if needed
  window.__attachNoteLimiter = () => findNoteTextareas().forEach(attach);
})();
